import { Helmet } from 'react-helmet-async';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';
import Navbar from '@/components/layout/Navbar';
import Footer from '@/components/layout/Footer';
import PremiumBackground from '@/components/layout/PremiumBackground';
import AdminCheckWrapper from '@/components/analytics/admin/AdminCheckWrapper';
import InstitutionalDashboardContent from '@/components/admin/institutional/InstitutionalDashboardContent';

const InstitutionalDashboard = () => {
  const navigate = useNavigate();

  return (
    <AdminCheckWrapper>
      {() => (
        <>
          <Helmet>
            <title>Institutional Dashboard | Fraunhofer ENAS</title>
            <meta name="description" content="Institutsübergreifendes Dashboard für Paper-Qualität und AI Review Management." />
          </Helmet>

          <Navbar />

          <PremiumBackground variant="page" className="min-h-screen">
            <div className="pt-20">
              <div className="max-w-7xl mx-auto px-4 md:px-6 pt-4">
                <Button
                  variant="ghost"
                  size="sm"
                  onClick={() => navigate(-1)}
                  className="gap-2 text-muted-foreground hover:text-foreground"
                >
                  <ArrowLeft className="h-4 w-4" />
                  Zurück
                </Button>
              </div>

              <InstitutionalDashboardContent />
            </div>
          </PremiumBackground>

          <Footer />
        </>
      )}
    </AdminCheckWrapper>
  );
};

export default InstitutionalDashboard;
